import { MostrarMensaje } from './ManejoMensajes';
import { enlistaArrayCodigosMensajesIdiomas } from '../Actions/Generales/IdiomasAction';

const errorMessage = (response = { data: { errors: "", typeError: 'warning' }, statusText: "" }, dispatch) => {
    if (response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
    } else {
        MostrarMensaje(dispatch, 'error', [response.statusText]);
    }
};

export default errorMessage